import React from 'react'

import { SH3, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import ZetCoin from '@zet/svg/ZetCoin'

import {
  handleBasePayout,
  handleExtraCoins,
  handleExtraPayout,
} from '../../utils'
import { LoyaltyPayoutTypes } from '../../utils/interface'

const TableColumns = ({
  handleCoinsColumn,
  tier,
  handleExtraPayoutColumn,
  isPercentagePayout,
  basePayoutValue,
  categoryId,
  loyaltyPayoutData,
}: {
  handleCoinsColumn?: any
  handleExtraPayoutColumn?: any
  tier?: any
  isPercentagePayout?: boolean
  basePayoutValue?: number | string
  categoryId?: number | string
  loyaltyPayoutData: LoyaltyPayoutTypes
}) => {
  return (
    <XStack className="w-full">
      <Stack className="flex-1">
        <Stack className={`items-center px-5 py-2`}>
          <SH3 className="text-grays-60">{i18n.t('brandDetails.basic')}</SH3>
        </Stack>
        {handleBasePayout(tier, isPercentagePayout, basePayoutValue)?.map(
          (item, index) => (
            <Stack
              className={`items-center  py-2 ${item?.bgColor} w-full`}
              key={index}
            >
              {item?.amount}
            </Stack>
          )
        )}
      </Stack>
      {handleExtraPayoutColumn() && Boolean(loyaltyPayoutData?.GENIUS) && (
        <Stack className="flex-1">
          <Stack className={`items-center px-5 py-2`}>
            <SH3 className="text-grays-60">{i18n.t('brandDetails.bonus')}</SH3>
          </Stack>
          {handleExtraPayout(tier, loyaltyPayoutData)?.map((item, index) => {
            return (
              <Stack
                className={`items-center  py-2 ${item?.bgColor} w-full`}
                key={index}
              >
                {item?.amount}
              </Stack>
            )
          })}
        </Stack>
      )}
      {handleCoinsColumn() && (
        <Stack className="flex-1">
          <Stack className={`items-center px-3 py-2`}>
            <SH3 className="text-grays-60">
              {i18n.t('brandDetails.zetCoins')}
            </SH3>
          </Stack>
          {handleExtraCoins(tier, categoryId).map((item, index) => (
            <Stack
              className={`items-center  py-2 ${item?.bgColor} w-full`}
              key={index}
            >
              <XStack className="items-center justify-between">
                {item?.coins}
                <ZetCoin height={16} width={20} />
              </XStack>
            </Stack>
          ))}
        </Stack>
      )}
    </XStack>
  )
}

export default TableColumns
